import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { UntypedFormGroup, Validators, UntypedFormControl, UntypedFormBuilder, } from '@angular/forms';
import { FormFieldsTrimer } from 'src/app/shared/Validations/FormFieldsTrimer';
import * as _moment from 'moment';
import { ReportingServiceService } from 'src/app/shared/services/reporting-service.service';
import { UserMultiColumnDropdownComponent } from '../user-multi-column-dropdown/user-multi-column-dropdown.component';
import { ErrorMessages } from 'src/app/shared/common/errormessages';
import { validationmethod } from 'src/app/shared/common/validationmethod';
import { LocalStorageSettingsService } from 'src/app/shared/services/local-storage-settings.service';
import { ActivatedRoute, Router } from '@angular/router';
import { element } from 'protractor';
import { ReportlinksserviceService } from '../reportlinks/reportlinksservice.service';
import { Actionbutton } from 'src/app/shared/common/Actionbutton';
import { constants } from 'src/app/shared/common/contants';


const moment =  _moment;

export interface ConditionalOPeratorTypeWhere {
  name: string,
  value: string
}

export interface LogicalOperatorTypeWhere {
  name: string,
  value: string
}

export interface ArrangeTypeOrderBy {
  name: string,
  value: string
}

export interface AggregateDataBy {
  name: string,
  value: string
}

export interface ArrangeMyDataBy {
  name: string,
  value: string
}

export interface ArrangeMyTypeBy {
  name: string,
  value: string
}

@Component({
    selector: 'app-report-creation',
    templateUrl: './report-creation.component.html',
    styleUrls: ['./report-creation.component.scss'],
    standalone: false
})
export class ReportCreationComponent implements OnInit {
  //ngModel
  whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "","enterValueWhereDate":"","logicalOperatorWhere": "" };

  barArray = { "type": "column", "xKey": "", "yKeys": "","grouped":"true","label": "{}","strokeWidth":"0" };

  groupByData = { "fieldsGroupBy": "" };

  orderByData = { "fieldsOrderBy": "", "arrangeOrderBy": "" };

  aggregateByData = {"fieldsAggregateBy": "", "arrangeaggregateBy": "" };

  datasetFormByData = {"namedatasetBy" : "", "typedatasetBy": "", "detailsdatasetBy": "", "accesstypedatasetBy": "" };

  formulaFieldsByData = {"labelformulafieldsBy" : "", "returntypeformulafieldsBy" : "", "objectformulafieldsBy" : "", "functionsformulafieldsBy" : "", "oprationsformulafieldsBy" : ""};

  reportingObject = { "from": "", "queryArray": [], "join": [], "firstJoin": [], "secondJoin": [], "thirdJoin": [], "fourthJoin": [] };

   reportingObjectSend = {"reportMainConfigurationId":"","object":"", "queryArray": [], "from":"", "joins": [], "where":[], "groupBy": [], "orderBy": [] ,"type":"","name":"","userAccess":"","aggregateBy":[]};

   reportCreationData={"datasetname":"","reporttemplatename":"","details":"","type":"","accesstype":"","vaultDocumentType":"","documentsubtype":"","vaultClasification":"","vaultTemplate":"","vaultbinderTemplate":"","datalakeType":""}

   selectedValue: boolean = true;

  columnDefsForObjects;

  //columnDefsForTables;

  columnDefsForTablesFields;

  columnDefsForReportingConfiguration;

  columnDefsForWhere;

  columnDefsForAggregate;

  columnDefsForOrderBy;

  rowSelection;

  rowSelectionForTablesFields;

  //gridApi;

  gridApiForTablesFields;

  gridApiForReportingConfiguration;

  gridApiForWhere;

  gridApiForOrderBy;

  gridApiForAggregate;

  tablesFields = [];
  tableFields = [];

  defaultColDefs;

  ngModelObjectDivision = [];

  tableNames = [];
  join = [];
  firstJoin = [];
  secondJoin = [];
  thirdJoin = [];
  fourthJoin = [];
  from = [];
  whereValueDateFormat = moment(null)

  selectedObject;

  selectObjectId;

  //selectedTable;

  paginationPageSize;

  paginationNumberFormatter;

  rowClassRules;

  lastpage;

  currentpage;

  nextpage;

  nextpageplusone;

  totalpages;

  pagesize;

  screenNames;

  columnNames = [];

  rowsData: any = [];

  formValidWhere: UntypedFormGroup;
  formulaFields:UntypedFormGroup;
  datasetForm:UntypedFormGroup;

  validationMessagesWhere;

  fieldsData: any = [];

  fieldsTemp:any = [];

  aggregateArray: any = [];

  where = [];

  formValidGroupBy: UntypedFormGroup;

  validationMessagesGroupBy;

  groupBy = [];

  formValidOrderBy: UntypedFormGroup;

  validationMessagesOrderBy;

  xdummydata:String;

  orderBy = [];

  whereAgGrid = [];

  components: any;

  orderByAgGrid = [];

  aggregateAgGrid = [];

  aggregateBy = [];

  showFilters: boolean = true;
  show: boolean = false;
  isExpandFilters: boolean = false;
  showAggregate: boolean = false;
  isExpandAggregate: boolean = false;
  showOrderBy: boolean = false;
  isExpandOrderBy: boolean = false;
  allFields: any = [];
  columnDefsForSelectedFields: any;
  gridApiForSelectedTablesFields: any;
  fieldsDataToRemove: any;
  selectedFieldsData: any = [];
  selectedFieldsDataToPush: any = [];
  temp: any = [];
  selectedFields: any = [];
  validations_form: UntypedFormGroup;
  defaultColDef
  ngModelObjectTemporary
  butttonname
  validation_messages
  editMyDataSet: any
  orderByShow: boolean = false;
  aggreageShow:boolean = false;
  fieldChange:boolean = true;
  dateChange:boolean = false;
  showFilter:boolean = false;
  saveButton:boolean = true;
  updateButton:boolean = false;
  showgridData:boolean = true;
  barChartData:boolean = false;
  pieChartData:boolean = false;
  showChartData:boolean = false;

  tableNamestemp=[];
  keyStrings = [];
  aggretaefields=[];
  group = [];
  aliasString
  aggregateValue
  xKeydata:any = [];
  ykeydata:any = []

  getdata: any = []

  xdata = [];

  eachBar = [];

  editData;

  xAxis1;
  yAxis1;

  editresponse:any = []

  gridApi;

  options: any;

  public listItems: Array<string> = [];

  eachxdata
  paramstemp
  selectedTableFields

  beverageSpending = [
    {
        beverage: 'Coffee',
        Q1: 10,
        Q2: 50,
        Q3: 60,
        Q4: 70,
    },
    {
        beverage: 'Tea',
        Q1: 20,
        Q2: 30,
        Q3: 40,
        Q4: 50,
    },
    {
        beverage: 'Milk',
        Q1: 10,
        Q2: 10,
        Q3: 10,
        Q4: 20,
    },
];

  dataSetObject = {
    datasetname: '',
    accesstype: '',
    fieldslist: '',
    userid: '',
    objectid: '',
    createdDate: '',
    createdBy: '',
    lastModifiedDate: '',
    lastModifiedBy: ''
  }

  backgroundColorButton = "";

  //need to remove

save
update
barChart
value;
gridColumnAPI;
overlayNoRowsTemplate;
columnDefs
rowData
private gridColumnApi;
grid

backgroundColorScreen="";
buttonColor="";
isExpand: boolean = true
k;
  constructor(private msg: ErrorMessages, private validation: validationmethod, private service: ReportingServiceService, private spinner: NgxUiLoaderService, private snackbar: MatSnackBar, private dialog: MatDialog, private fb: UntypedFormBuilder, private localStorageSettings: LocalStorageSettingsService, private formFieldsTrimer: FormFieldsTrimer,private linkservice: ReportlinksserviceService,private constants: constants) { 
    //messages for validations
    this.validation_messages = this.msg.reportMessages;
    this.validationMessagesGroupBy = this.msg.groupByMessages;

    this.validationMessagesGroupBy = this.msg.orderByMessages;
    //cell rendering in ag-grid
    this.components = {
      buttonRenderer: Actionbutton,
    }
  }

  formValidation() {
    this.validations_form = new UntypedFormGroup({
      selectdataSet: new UntypedFormControl('', [Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100)]),
      reporttemplatename: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100),Validators.pattern('^[a-zA-Z]+$')]),
      details: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100),Validators.pattern('^[a-zA-Z]+$')]),
      type: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      accesstype: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      vaultDocumentType:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      documentsubtype:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      vaultClasification:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      vaultTemplate:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      vaultbinderTemplate:new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      dataLakeType: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),

    });
  }

  formulaFieldsValidation(){
    this.formulaFields = new UntypedFormGroup({
      label: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator, Validators.maxLength(100),Validators.pattern('^[a-zA-Z]+$')]),
      returntype: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      object: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      functions: new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator]),
      oprations : new UntypedFormControl('',[Validators.required, this.validation.noWhitespaceValidator])
    })
  }
  toggletextbox(){
    this.selectedValue=!this.selectedValue;
  }

  SendData() {
    console.log(this.dataSetObject);
    if (!this.validations_form.valid) {
      console.log("If Condition")
      // displaying validation messages
      this.validation.validateAllFormFields(this.validations_form);
      this.validation.getvalidationmessage();

      return
    } else {
      console.log(this.temp)
      console.log("Else Condition")
      if (this.butttonname == "Save") {
        console.log("Save Button");
        this.dataSetObject.objectid = "";
        if (this.temp.length == 0) {
          console.log("Check condition for selcet fields");
          this.snackbar.open("Dataset is empty please select at least one attributes to processed.", "OK", {
            duration: 5000,
          });
          console.log("inside if Common Function declared")

        }
      } else if (this.butttonname = "Update") {
        console.log("Update Button");
        console.log(this.dataSetObject.objectid)
        if (this.temp.length == 0) {
          console.log("Check condition for selcet fields");
          this.snackbar.open("Dataset is empty please select at least one attributes to processed.", "OK", {
            duration: 5000,
          });
          console.log("inside if Common Function declared")
        }
      }
      if (this.temp.length != 0) {
        this.dataSetObject.fieldslist = this.temp;
        this.spinner.start()
        this.service.insertReportData(this.dataSetObject).subscribe(response => {
          console.log(response);
          console.log("Inside Service")
          if (response.error === true) {
            this.spinner.stop()
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
          } else {
            console.log(response)
            this.snackbar.open(response.statusMessage, "OK", {
              duration: 5000,
            });
            this.spinner.stop()
          }
          this.ClearData();
        })
      }
    }
  }

  ngOnInit() {

    this.formValidWhere = this.fb.group({
      fieldsWhere: '',
      conditionalOperatorWhere: '',
      enterValueWhere: '',
      fieldsOrderBy: '',
      arrangeOrderBy: '',
      fieldsAggredateBy: '',
      arrangeaggregateBy: ''
    });

    this.validations_form = this.fb.group({
      selectdataSet: '',
      reporttemplatename: '',
      details: '',
      type: '',
      accesstype: '',
      vaultDocumentType:'',
      documentsubtype:'',
      vaultClasification:'',
      vaultTemplate:'',
      vaultbinderTemplate:''
    });

     this.formValidationsWhere();
    // this.butttonname = "Save";
    this.formValidation();

    this.formulaFieldsValidation();
    this.datasetFormValidation();

    this.butttonname = "Save";

    this.columnDefsForObjects = [
      {
        headerName: "Base Objects",
        headerTooltip: "Base Objects",
        tooltipValueGetter: params => "Base Objects : " + params.value,
        field: "object",
        filter: "agTextColumnFilter",
        width: 400,
        headerClass: 'headerClassName'
      }
    ];

    this.columnDefsForTablesFields = [
      {
        headerName: "Attributes ",
        headerTooltip: "Attributes",
        tooltipValueGetter: params => "Attributes : " + params.value,
        field: "attributeNameAndFields",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];

    this.columnDefsForSelectedFields = [
      {
        headerName: "Selected Fields",
        headerTooltip: "Selected Fields",
        tooltipValueGetter: params => "Selected Fields : " + params.value,
        field: "attributeNameWithFields",
        filter: "agTextColumnFilter",
        width: 400,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        cellStyle: { " padding-left": "5px" }
      }
    ];
    this.columnDefs = [{
      headerName: 'Action', filter: false, cellRenderer: 'buttonRenderer',
      pinned:'left',
      lockPinned:true,
      cellRendererParams: {
        //edit: this.EditIcon.bind(this),
        //delete: this.deleteIcon.bind(this),
      }, width: 250
    },

      { headerName: 'Row Id', field: 'reportcreationid', filter: 'agTextColumnFilter', width: 150 },
      { headerName: 'Report Name', headerTooltip: 'Report Name', tooltipValueGetter: (params) => 'Report Name : ' + params.value, field: 'name', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Dataset Name', headerTooltip: 'Dataset Name', tooltipValueGetter: (params) => 'Dataset Name : ' + params.value, field: 'datasetname', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Access Type', headerTooltip: 'Access Type', tooltipValueGetter: (params) => 'Access Type : ' + params.value, field: 'accesstype', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Details', headerTooltip: 'Details', tooltipValueGetter: (params) => 'Details : ' + params.value, field: 'details', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Type', headerTooltip: 'Type', tooltipValueGetter: (params) => 'Type : ' + params.value, field: 'type', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Filters', headerTooltip: 'Filters', tooltipValueGetter: (params) => 'Filters : ' + params.value, field: 'filters', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Sorting', headerTooltip: 'Sorting', tooltipValueGetter: (params) => 'Sorting : ' + params.value, field: 'sorting', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Aggregate', headerTooltip: 'Aggregate', tooltipValueGetter: (params) => 'Aggregate : ' + params.value, field: 'aggregate', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Calculated Fields', headerTooltip: 'Calculated Fields', tooltipValueGetter: (params) => 'Calculated Fields : ' + params.value, field: 'calculatedfields', filter: 'agTextColumnFilter', width: 250 },
      { headerName: 'Status', headerTooltip: 'Status', tooltipValueGetter: (params) => 'Status : ' + params.value, field: 'status', filter: 'agTextColumnFilter', width: 250 },
    ]
    // if the record has status==no , row color will change
    this.rowClassRules = {
      "sick": function (params) {
        var numSickDays = params.node.data.status;
        return numSickDays === "No" || numSickDays === null;
      },

    };
    // below object is resizable, sorting and filter for ag-grid
    this.defaultColDef = {
filterParams: {
        maxNumConditions: 2,
        numAlwaysVisibleConditions: 2,
        defaultJoinOperator: 'OR'
      },
      sortable: true,
      resizable: true,
      filter: true
    };
    this.rowSelection = this.constants.rowselection;
    this.paginationPageSize = this.constants.pagesize;
    this.paginationNumberFormatter = function (params) {
      return params.value.toLocaleString();
    };


    this.backgroundColorScreen = this.localStorageSettings.getSettings("ColorD");
    this.buttonColor = this.localStorageSettings.getSettings("ColorA");
  }
    //excel export function
    onBtExport() {
      this.gridApi.exportDataAsCsv();
    }
  
    //pagination code
    onPaginationChanged() {
      if (this.gridApi) {
        this.lastpage = this.gridApi.paginationIsLastPageFound();
        this.currentpage = this.gridApi.paginationGetCurrentPage() + 1
        this.nextpage = this.gridApi.paginationGetCurrentPage() + 1 + 1
        this.nextpageplusone = this.gridApi.paginationGetCurrentPage() + 1 + 1 + 1
        this.totalpages = this.gridApi.paginationGetTotalPages()
      }
    }
    //this function is for going to the given page number 
    onSearchChange(searchValue: number) {
  
      this.gridApi.paginationGoToPage(searchValue - 1);
    }
  
    // below function is for changing the no of rows per page
    onPageSizeChanged(newPageSize) {
      var value = this.pagesize
      this.gridApi.setGridOption('paginationPageSize', Number(value));
    }
  
    // below function is for going to next page
    onBtNext() {
      console.log("next")
      this.gridApi.paginationGoToNextPage();
    }
  
    // below function for going to previous page
    onBtPrevious() {
      console.log("previous")
      this.gridApi.paginationGoToPreviousPage();
    }
  
    // below function for going to first page
    onBtFirst() {
      console.log("first")
      this.gridApi.paginationGoToFirstPage();
    }
  
    // below function for going to last page
    onBtLast() {
      console.log("last")
      this.gridApi.paginationGoToLastPage();
    }
    //pagination code ends

  onGridReady(params){
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.sizeColumnsToFit();
    this.linkservice.retrievereportlinks().subscribe(response=>{
      console.log(response);
      // checking if response is true or not
      if (response.error == true) {
        this.snackbar.open(response.statusMessage, "OK", {
          duration: 5000,
        });
        this.getdata = null;
        params.api.setGridOption('rowData', this.getdata)

      } else {

        console.log(response)
        this.getdata = response
        console.log(this.getdata)
        params.api.setGridOption('rowData', this.getdata)

      }
    });
  }

  onGridReadyForObjects(params) {

    // this.service.retrieveObjects().subscribe(res => {

    //   this.spinner.start();

    //   console.log(res);

    //   // checking if response is true or not
    //   if (res.error === true) {

    //     this.spinner.stop();

    //     this.snackbar.open(res.message, "OK", { duration: 5000 });

    //     params.api.setGridOption('rowData', []);

    //   } else {

    //     this.spinner.stop();

    //     params.api.setGridOption('rowData', res);

    //   }

    // });

  }
  // onGridReadyForObjects(params) {
  //   this.gridApi = params.api
  //   this.service.retrieveObjects().subscribe(res => {
  // }
  // onGridReadyForObjects(params) {
  //   this.gridApi = params.api
  //   this.service.retrieveObjects().subscribe(res => {

  //     this.spinner.start();

  //     console.log(res);

  //     // checking if response is true or not
  //     if (res.error === true) {

  //       this.spinner.stop();

  //       this.snackbar.open(res.message, "OK", { duration: 5000 });

  //       params.api.setGridOption('rowData', []);

  //     } else {

  //       this.spinner.stop();

  //       this.gridApi.setGridOption('rowData', res);

  //       console.log(this.editresponse)
  //       if (this.editresponse.object != undefined) {
  //         this.gridApi.forEachNode(node => {
  //             console.log(node.data)
  //             console.log(this.editresponse.object)
  //             if(node.data.object== this.editresponse.object){
  //               node.setSelected(true)
  //             }
             
    
    
  //         });
  //       }


  //     }

  //   });

  // }


  onGridReadyForTablesFields(params, tableName) {
    this.paramstemp = params;
    console.log(tableName)
    this.gridApiForTablesFields = params;
    console.log(params)
    this.paramstemp.api.setGridOption('rowData', tableName);
    //this.gridApiForTablesFields.setGridOption('rowData', res);

    this.gridApiForTablesFields = params.api;

    params.api.setGridOption('rowData', []);

  }

  onGridReadyForWhere(params) {

    this.gridApiForWhere = params.api;

    if (this.whereAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForWhere.setGridOption('rowData', this.whereAgGrid);

    }

  }

  onGridReadyForAggregate(params) {

    this.gridApiForAggregate = params.api;

    if (this.aggregateAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForAggregate.setGridOption('rowData', this.aggregateAgGrid);

    }

  }

  onGridReadyForOrderBy(params) {

    this.gridApiForOrderBy = params.api;

    if (this.orderByAgGrid.length == 0) {

      params.api.setGridOption('rowData', []);

    }

    else {

      this.gridApiForOrderBy.setGridOption('rowData', this.orderByAgGrid);

    }

  }

  cellClickedObjects(e) {

    console.log(e)

    console.log(e.value);

    this.service.retrieveTablesFields(e.value).subscribe(res => {

      this.spinner.start();

      console.log(res);

      // checking if response is true or not
      if (res.error === true) {

        this.spinner.stop();

        this.snackbar.open(res.message, "OK", { duration: 5000 });

        this.allFields = [];

        this.selectedFieldsData = [];

        this.gridApiForTablesFields.setGridOption('rowData', []);

      } else {

        this.spinner.stop();

        this.allFields = res;

        this.selectedObject = e.value;

        this.selectObjectId = e.data.objectId

        console.log(this.selectedObject)
        this.onGridReadyForTablesFields(this.paramstemp,res)

        this.columnDefsForReportingConfiguration = [];

      }

    });

  }
  
  whereKey(e){
    this.fieldChange = true;
    this.dateChange=false;
    console.log(e)
    console.log(this.fieldsData)
    for(let i=0;i<this.fieldsData.length;i++){
      if(this.fieldsData[i].townshipNameAndFields == e){
        if(this.fieldsData[i].datatype == "Date"){
          this.dateChange=!this.dateChange;
          this.fieldChange = false;
        }else{
          this.dateChange=false;
        }
        }
      }
    }

    cancel() {

      this.gridApiForTablesFields.setGridOption('rowData', []);
  
      this.columnDefsForReportingConfiguration = [];
  
      this.gridApiForReportingConfiguration.setGridOption('rowData', []);
  
      this.where = [];
  
      this.groupBy = [];
  
      this.orderBy = [];
  
      this.fieldsData = [];
  
      this.aggregateBy=[];
  
      this.aggregateArray=[];
  
      this.show = false;
      this.orderByShow = false;
      this.aggreageShow = false;
      this.dateChange = false;
  
    }
    

  // reportConfigurationRun() {

  //   console.log(this.columnNames);

  //   console.log(this.rowsData);

  //   var columnsDefsAnother = [];

  //   for (var i = 0; i < this.columnNames.length; i++) {
  //     columnsDefsAnother.push({
  //       headerName: this.columnNames[i],
  //       headerTooltip: this.columnNames[i],
  //       tooltipValueGetter: params => params.value,
  //       field: this.columnNames[i],
  //       filter: 'agTextColumnFilter',
  //       width: 150
  //     });
  //   }

  //   //Array to bind data to ag-grid.
  //   this.columnDefsForReportingConfiguration = columnsDefsAnother;

  //   this.gridApiForReportingConfiguration.setGridOption('rowData', []);

  //   this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);

  // }



  //Excel export function.
  
  reportConfigurationRun() {

    //this.columnNames = this.data.columnNames;

    console.log(this.columnNames);

    console.log(this.rowsData);

    var columnsDefsAnother = [];

    for (var i = 0; i < this.columnNames.length; i++) {
      columnsDefsAnother.push({
        headerName: this.columnNames[i],
        headerTooltip: this.columnNames[i],
        tooltipValueGetter: params => params.value,
        field: this.columnNames[i],
        filter: 'agTextColumnFilter',
        width: 150
      });
    }
    console.log(this.xKeydata)
    console.log(this.ykeydata)
  //   this.options = {
  //     data: this.rowsData,
  //     padding: {
  //       top: 40,
  //       right: 40,
  //       bottom: 40,
  //       left: 40,
  //     },
  //     series: [{
  //         type: 'column',
  //         xKey: this.xKeydata,
  //         yKeys: this.ykeydata,
  //         grouped: true,
  //         label: {},
  //         strokeWidth: 0,
  //     }],
  //     legend: {
  //       spacing: 40,
  //     },
  // };

    //Array to bind data to ag-grid.
    this.columnDefsForReportingConfiguration = columnsDefsAnother;

    this.gridApiForReportingConfiguration.setGridOption('rowData', []);

    this.gridApiForReportingConfiguration.setGridOption('rowData', this.rowsData);


  }

  modifingCharts(){
    let xAxis2;
    let yAxis2;
    let data:any =[];
    this.xdata = [];
    console.log(this.rowsData)
    console.log(this.xKeydata)
    console.log(this.ykeydata)
    for(let i =0;i<=this.rowsData.length-1;i++){
      let xdummy="";
      let ydummy="";
      console.log(Object.keys(this.rowsData[i]))
      console.log(Object.values(this.rowsData[i]))
      for(let j = 0;j<=this.xKeydata.length-1;j++){
        if(Object.keys(this.rowsData[i]).includes(this.xKeydata[j])){
          this.xAxis1 = this.rowsData[i]
          xAxis2 = this.xKeydata[j]
          if(xdummy == ""){
            xdummy = this.xAxis1[xAxis2];
          }else{
          xdummy = xdummy+","+ this.xAxis1[xAxis2];
        }
      }
    }
        for(let y = 0;y<=this.ykeydata.length-1;y++){
          if(Object.keys(this.rowsData[i]).includes(this.ykeydata[y])){
            this.yAxis1 = this.rowsData[i]
            yAxis2 = this.ykeydata[y]
              ydummy = this.yAxis1[yAxis2];
           
          }
          let tempData = { "xAxis": xdummy, "yAxis":ydummy};

          this.xdata.push(tempData);
          console.log(this.xdata)
        }
        
      

    }
    this.xdummydata="";
  }

  pieChart(){
    this.modifingCharts()
    console.log(this.ykeydata.length)
    this.pieChartData = !this.pieChartData
    if(this.pieChartData == false){
      this.showgridData = true;
    }else{
      this.showgridData = false;
    }
    this.barChartData = false;
    if(this.ykeydata.length>1){
      this.showgridData=true;
      this.pieChartData = !this.pieChartData
      this.snackbar.open("Pie chart not available","OK", { duration: 5000 })
    }else{
    this.options = {
      data: this.xdata,
      series: [{
          type: 'pie',
          labelKey: ['xAxis'],
          angleKey:['yAxis'],
          angleNames:[this.ykeydata]
      }],
      legend: {
        position: 'bottom',
      },
  };
}
  }

  // onExport() {
  //   this.gridApiForReportingConfiguration.exportDataAsCsv();
  // }

  // //Pagination code.
  // onPaginationChanged() {
  //   if (this.gridApiForReportingConfiguration) {
  //     this.lastPage = this.gridApiForReportingConfiguration.paginationIsLastPageFound();
  //     this.currentPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1;
  //     this.nextPage = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1;
  //     this.nextPagePlusOne = this.gridApiForReportingConfiguration.paginationGetCurrentPage() + 1 + 1 + 1;
  //     this.totalPages = this.gridApiForReportingConfiguration.paginationGetTotalPages();
  //   }
  // }

  // //Below function is to load the ag-grid.
  // onGridReadyForReportingConfiguration(params) {

  //   this.gridApiForReportingConfiguration = params.api;

  //   // params.api.setGridOption('rowData', this.rowsData);

  // }

  // //this function is for going to the given page number.
  // onSearchChange(searchValue: number) {
  //   this.gridApiForReportingConfiguration.paginationGoToPage(searchValue - 1);
  // }

  // //Below function is for changing the no of rows per page.
  // onPageSizeChanged() {
  //   var value = this.pageSize;
  //   this.gridApiForReportingConfiguration.setGridOption('paginationPageSize', Number(value));
  // }

  // //Below function is for going to next page.
  // onNext() {
  //   this.gridApiForReportingConfiguration.paginationGoToNextPage();
  // }

  // //Below function is for going to previous page.
  // onPrevious() {
  //   this.gridApiForReportingConfiguration.paginationGoToPreviousPage();
  // }

  // //Below function is for going to first page.
  // onFirst() {
  //   this.gridApiForReportingConfiguration.paginationGoToFirstPage();
  // }

  // //Below function is for going to last page.
  // onLast() {
  //   this.gridApiForReportingConfiguration.paginationGoToLastPage();
  // }

  cellClickedFields(e){
    console.log(e)
  }

  onselection(params){
    console.log(params)
  }

  onRowSelected(event) {

    this.fieldsData = this.paramstemp.api.getSelectedRows();

    this.selectedFieldsData = this.fieldsData;

    console.log(this.selectedFieldsData);

  }

  formValidationsWhere() {
    // form validations  
    this.formValidWhere = new UntypedFormGroup({
      fieldsWhere: new UntypedFormControl('', []),
      conditionalOperatorWhere: new UntypedFormControl('', []),
      enterValueWhere: new UntypedFormControl('', []),
      logicalOperatorWhere: new UntypedFormControl('', []),
      fieldsOrderBy: new UntypedFormControl('', []),
      arrangeOrderBy: new UntypedFormControl('', []),
      fieldsAggredateBy:new UntypedFormControl('',[]),
      arrangeaggregateBy:new UntypedFormControl('',[])
    });
  }


  datasetFormValidation(){
    this.datasetForm = new UntypedFormGroup({
      name : new UntypedFormControl(''),
      type : new UntypedFormControl(''),
      details : new UntypedFormControl(''),
      accesstype : new UntypedFormControl('')
    })
  }

  formValidationsGroupBy() {
    // form validations  
    this.formValidGroupBy = new UntypedFormGroup({
      fieldsGroupBy: new UntypedFormControl('', [Validators.required])
    });
  }

  formValidationsOrderBy() {
    // form validations  
    this.formValidOrderBy = new UntypedFormGroup({
      
    });
  }

  connect() {

    console.log(this.whereData);

    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);

      this.formFieldsTrimer.clean(this.whereData);

    }

  }

  conditionalOperatorDataWhere: ConditionalOPeratorTypeWhere[] = [
    { name: "Matches", value: "=" },
    { name: "Does Not Matches", value: "<>" },
    { name: "Starts With", value: "Starts with" },
    { name: "Ends With", value: "Ends with" },
    { name: "Contains", value: "Contains" },
    { name: "Greater than or equals", value: ">=" },
    { name: "Is greater than", value: ">" },
    { name: "Less than or equals", value: "<=" },
    { name: "Is less than", value: "<" },
  ];

  logicalOperatorDataWhere: LogicalOperatorTypeWhere[] = [
    { name: "And", value: "And" },
    { name: "Or", value: "Or" }
  ];

  arrangeDataOrderBy: ArrangeTypeOrderBy[] = [
    { name: "Ascending", value: "ASC" },
    { name: "Descending", value: "DESC" }
  ];

  arrangeDataBy: AggregateDataBy[] = [
    { name: "Average", value: "avg" },
    { name: "Count", value: "count" },
    { name: "Group Concate", value: "group_concat" },
    { name: "Max", value: "max" },
    { name: "Min", value: "min" },
    { name: "Sum", value: "sum" },
  ];

  arrangeDatasetBy: ArrangeMyDataBy[]= [
    { name: "Public", value: "public" },
    { name : "Private", value : "private"}
  ];

  arrangeTypeBy: ArrangeMyTypeBy[]= [
    { name: "Type 1", value: "type1" },
    { name : "Type 2", value : "type2"}
  ];

  addWhere() {
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.whereData);
      this.formFieldsTrimer.clean(this.whereData);
      if(this.whereData.fieldsWhere==undefined || this.whereData.conditionalOperatorWhere == undefined || (this.whereData.enterValueWhere == undefined && this.whereData.enterValueWhereDate == undefined)){
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      }else{
      if(this.whereData.logicalOperatorWhere==undefined){
        this.whereData.logicalOperatorWhere="AND"
      }
      console.log(this.whereData.enterValueWhereDate)
      console.log(this.whereData.enterValueWhere)
      if(this.whereData.enterValueWhereDate== undefined){
        let tempWhere = { "whereKey": this.whereData.fieldsWhere, "whereCondition": this.whereData.conditionalOperatorWhere, "whereValue": this.whereData.enterValueWhere, "whereLogic": this.whereData.logicalOperatorWhere }
      
        this.where.push(tempWhere);
        this.showFilter= true;
        this.whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "logicalOperatorWhere": "","enterValueWhereDate":"" };
  
        tempWhere = { "whereKey": "", "whereCondition": "", "whereValue": "", "whereLogic": "" }
      }else{
        this.whereValueDateFormat =moment(this.whereData.enterValueWhereDate) 
        this.whereData.enterValueWhereDate = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        console.log(this.whereData.enterValueWhereDate)
        let tempWhere = { "whereKey": this.whereData.fieldsWhere, "whereCondition": this.whereData.conditionalOperatorWhere, "whereValue": this.whereData.enterValueWhereDate, "whereLogic": this.whereData.logicalOperatorWhere }
      
        this.where.push(tempWhere);
        this.showFilter= true;
        this.whereData = { "fieldsWhere": "", "conditionalOperatorWhere": "", "enterValueWhere": "", "logicalOperatorWhere": "","enterValueWhereDate":"" };
  
        tempWhere = { "whereKey": "", "whereCondition": "", "whereValue": "", "whereLogic": "" }

      }
      


      console.log(this.where);

      this.formValidWhere.reset();

      this.formValidationsWhere();
    }

    }

  }
  addOrderBy(){
    if (!this.formValidWhere.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidWhere);

      this.validation.getvalidationmessage();

    }

    else {
      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.orderByData);
      this.formFieldsTrimer.clean(this.orderByData);
      if(this.orderByData.fieldsOrderBy==undefined || this.orderByData.arrangeOrderBy== undefined){
        this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
      }else{
      if(this.orderByData.arrangeOrderBy==undefined){
        this.orderByData.arrangeOrderBy="AND"
      }
      console.log(this.orderByData.fieldsOrderBy)
      console.log(this.orderByData.fieldsOrderBy)
      if(this.orderByData.fieldsOrderBy== undefined){
        let tempWhere = { "whereKey": this.orderByData.fieldsOrderBy, "whereCondition": this.orderByData.arrangeOrderBy}
      
        this.where.push(tempWhere);
        this.showOrderBy= true;
        this.orderByData = { "fieldsOrderBy": "", "arrangeOrderBy": ""};
  
        tempWhere = { "whereKey": "", "whereCondition": "",}
      }else{
        this.whereValueDateFormat =moment(this.orderByData.fieldsOrderBy) 
        this.orderByData.fieldsOrderBy = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
        console.log(this.orderByData.fieldsOrderBy)
        let tempWhere = { "whereKey": this.orderByData.fieldsOrderBy, "whereCondition": this.orderByData.arrangeOrderBy}
      
        this.where.push(tempWhere);
        this.showOrderBy= true;
        this.orderByData = { "fieldsOrderBy": "", "arrangeOrderBy": ""};
  
        tempWhere = { "whereKey": "", "whereCondition": ""}

      }
      


      console.log(this.orderBy);

      this.formValidWhere.reset();

      this.formValidationsWhere();
    }

    }
  }


  addAggregate() {
    if (!this.formValidWhere.valid) {

    // displaying validation messages
    this.validation.validateAllFormFields(this.formValidWhere);

    this.validation.getvalidationmessage();

  }

  else {
    //api call to insert data
    this.formFieldsTrimer.trimFormfieldsData(this.aggregateByData);
    this.formFieldsTrimer.clean(this.aggregateByData);
    if(this.aggregateByData.fieldsAggregateBy==undefined || this.aggregateByData.arrangeaggregateBy== undefined){
      this.snackbar.open("Not a valid filter", "OK", { duration: 5000 });
    }else{
    if(this.aggregateByData.arrangeaggregateBy==undefined){
      this.aggregateByData.arrangeaggregateBy="AND"
    }
    console.log(this.aggregateByData.fieldsAggregateBy)
    console.log(this.aggregateByData.fieldsAggregateBy)
    if(this.aggregateByData.fieldsAggregateBy== undefined){
      let tempWhere = { "whereKey": this.aggregateByData.fieldsAggregateBy, "whereCondition": this.aggregateByData.arrangeaggregateBy}
    
      this.where.push(tempWhere);
      this.showAggregate= true;
      this.aggregateByData = { "fieldsAggregateBy": "", "arrangeaggregateBy": ""};

      tempWhere = { "whereKey": "", "whereCondition": "",}
    }else{
      this.whereValueDateFormat =moment(this.aggregateByData.fieldsAggregateBy) 
      this.aggregateByData.fieldsAggregateBy = moment(this.whereValueDateFormat).format('YYYY-MM-DD');
      console.log(this.aggregateByData.fieldsAggregateBy)
      let tempWhere = { "whereKey": this.aggregateByData.fieldsAggregateBy, "whereCondition": this.aggregateByData.arrangeaggregateBy}
    
      this.where.push(tempWhere);
      this.showAggregate= true;
      this.aggregateByData = { "fieldsAggregateBy": "", "arrangeaggregateBy": ""};

      tempWhere = { "whereKey": "", "whereCondition": ""}

    }
    


    console.log(this.aggregateBy);

    this.formValidWhere.reset();

    this.formValidationsWhere();
  }

  }

  }

  createreport(){
    console.log(this.formValidWhere.value);
    console.log(this.validations_form.value);
    this.formValidWhere.reset();
    this.validations_form.reset();
  }

  
  addGroupBy() {

    if (!this.formValidGroupBy.valid) {

      // displaying validation messages
      this.validation.validateAllFormFields(this.formValidGroupBy);

      this.validation.getvalidationmessage();

    }

    else {

      //api call to insert data
      this.formFieldsTrimer.trimFormfieldsData(this.groupByData);

      this.formFieldsTrimer.clean(this.groupByData);

      console.log(this.groupByData.fieldsGroupBy);

      this.groupBy.push(this.groupByData.fieldsGroupBy);

      console.log(this.groupBy);

      this.groupByData = { "fieldsGroupBy": "" };

      console.log(this.groupByData);

      this.formValidGroupBy.reset();

      this.formValidationsGroupBy();

    }

  }
  deleteWhere(k){
    console.log(k)
    this.where.splice(k,1);
    if(this.where.length ==0){
      this.showFilter = false;
    }
  }
  deleteOrder(k){
    console.log(k)
    this.orderBy.splice(k,1);
    if(this.orderBy.length ==0){
      this.showOrderBy = false;
    }
  }
  deleteAggregate(k){
    console.log(k)
    this.aggregateBy.splice(k,1);
    if(this.aggregateBy.length ==0){
      this.showAggregate = false;
    }
  }

  // onRowSelected(event) {
  //   console.log(event.data);
  //   console.log(event.node.selected);
  //   console.log(event.rowIndex);
  //   console.log(this.aggregateArray);
  //   if(event.node.selected == true){
  //     this.aggregateArray.push(event.data)
  //     this.reportingObjectSend.from = event.data.tableNames
  //     console.log(this.reportingObjectSend.from)
  //   } 
  //   if(event.node.selected == false){
  //     let contain = this.aggregateArray.includes(event.data);
  //   console.log(contain)
  //   if(contain == true){
  //     this.aggregateArray.splice(this.aggregateArray.indexOf(event.data),1)
  //   }
  //   if(this.reportingObjectSend.from == event.data){
  //     this.reportingObjectSend.from ==""; 
  //   }
  //     // this.aggregateArray.splice(event.data,1)
  //   }
  // }


  onGridReadyForSelectedTableFields(params, tableName) {
    this.selectedTableFields=params
    //this.gridApiForTablesFields = params.api;
    console.log(this.selectedTableFields)
    this.selectedTableFields.api.setGridOption('rowData', tableName);
    this.fieldsData = this.selectedTableFields.api.getSelectedRows();

  }


  ClearData() {
    this.butttonname = "Save"
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.dataSetObject.objectid = ""
    this.dataSetObject.datasetname = ""
    this.editMyDataSet = ""
    this.dataSetObject.accesstype = "public"
    this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
    this.validations_form.controls['dataSet'].reset();
  }

  //forward Icon Function decleation
  pushDataToSelectedFieldsGrid() {
    let uniq = {}
    console.log(this.selectedFieldsData);
    for (let i = 0; i < this.selectedFieldsData.length; i++) {
      this.selectedFieldsData[i].objectId = this.selectObjectId;
      this.selectedFieldsData[i].object = this.selectedObject;
      this.selectedFieldsData[i].attributeNameWithFields = this.selectedFieldsData[i].object + "." + this.selectedFieldsData[i].attributeNameAndFields;
      this.selectedFieldsDataToPush.push(this.selectedFieldsData[i]);
    }
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
  }

  // //double forward Icon Function decleation
  pushDataToSelectedFieldsGridComplete() {
    let uniq = {}
    console.log(this.allFields);
    for (let i = 0; i < this.allFields.length; i++) {
      this.allFields[i].objectId = this.selectObjectId;
      this.allFields[i].object = this.selectedObject;
      this.allFields[i].attributeNameWithFields = this.allFields[i].object + "." + this.allFields[i].attributeNameAndFields;
      this.selectedFieldsDataToPush.push(this.allFields[i]);
    }
    console.log(this.selectedFieldsDataToPush)
    //duplicates data not allowed
    this.temp = this.selectedFieldsDataToPush.filter(obj => !uniq[obj.attributeNameWithFields] && (uniq[obj.attributeNameWithFields] = true));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.pushDataToSelectedFieldsGrid();
  }

  // //double backward Icon Function decleation
  popDataToSelectedFieldsGridComplete() {
    this.selectedFieldsDataToPush.length = 0
    this.temp.length = 0
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,null)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', []);
  }

  //backward Icon Function decleation
  popDataToSelectedFieldsGrid() {
    this.temp = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
    console.log(this.temp)
    this.onGridReadyForSelectedTableFields(this.selectedTableFields,this.temp)
    //this.gridApiForSelectedTablesFields.setGridOption('rowData', this.temp);
    this.selectedFieldsDataToPush = this.temp.filter(item => !this.fieldsDataToRemove.includes(item));
  }

  onRowSelectedToRemove(ev) {
    console.log(ev);
    this.fieldsDataToRemove = this.selectedTableFields.api.getSelectedRows();
    console.log(this.fieldsDataToRemove);
  }

  // onRowSelectedToRemove(ev) {
  //   console.log(ev);
  //   this.fieldsDataToRemove = this.gridApiForSelectedTablesFields.getSelectedRows();
  //   console.log(this.fieldsDataToRemove);
  // }

  userMultiDropdown() {
    let dialogRef = this.dialog.open(UserMultiColumnDropdownComponent, {
      width: "70%",
      autoFocus: false,
      data: { ObjectId: this.dataSetObject.objectid }
    });

    // subcribe the popup after close
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result != undefined) {
        this.selectedFieldsDataToPush = [];
        this.butttonname = "Update";
        console.log(result.fieldslist.fieldListKeyName)
        this.dataSetObject.objectid = result.objectid;
        this.reportCreationData.datasetname= result.datasetname;
        this.dataSetObject.datasetname = result.datasetname;
        this.dataSetObject.accesstype = result.accesstype;
        this.selectedFieldsDataToPush = result.fieldslist;
        this.editMyDataSet = result.datasetname
        // this.service.retrieveFieldsData(result.datasetname)
        //   .subscribe(arg => {console.log(arg)
        //   });
        
        console.log(this.selectedFieldsDataToPush);
       // this.pushDataToSelectedFieldsGrid();
      }
    });
  }
  addicon() {
    this.isExpand = !this.isExpand;
  }

  

}
